// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Specular_Components_IconList from "../Specular.Components.IconList/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var md48 = /* #__PURE__ */ Specular_Dom_Element.class_("md-48");
var md36 = /* #__PURE__ */ Specular_Dom_Element.class_("md-36");
var md24 = /* #__PURE__ */ Specular_Dom_Element.class_("md-24");
var md18 = /* #__PURE__ */ Specular_Dom_Element.class_("md-18");
var md14 = /* #__PURE__ */ Specular_Dom_Element.class_("md-14");
var iconD = function (props) {
    return function (icn) {
        return Specular_Dom_Element.el("span")(append([ Specular_Dom_Element.class_("material-symbols-outlined"), Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.attr("translate")("no") ])(props))(Specular_Dom_Element.dynText(map(Specular_Components_IconList.description)(icn)));
    };
};
var iconD_ = function (icn) {
    return iconD(mempty)(icn);
};
var icon = function (props) {
    return function (icn) {
        return iconD(props)(pure(icn));
    };
};
var icon_ = function (icn) {
    return icon(mempty)(icn);
};
var fill = /* #__PURE__ */ Specular_Dom_Element.class_("md-fill");
export {
    fill,
    icon,
    iconD,
    iconD_,
    icon_,
    md14,
    md18,
    md24,
    md36,
    md48
};
export {
    MDIcon,
    add,
    addCircle,
    addCircleOutline,
    arrowBack,
    arrowDropDown,
    arrowRight,
    attachMoney,
    barChart,
    block,
    bookmark,
    build,
    call,
    campaign,
    cancel,
    check,
    checkCircle,
    checkCircleOutline,
    checkbox,
    checkboxOutline,
    clear,
    close,
    closeFullscreen,
    code,
    contactSupport,
    contentCopy,
    createNewFolder,
    delete,
    description,
    divider,
    dividerSpecial,
    done,
    download,
    dragIndicator,
    edit,
    error,
    expandLess,
    expandMore,
    exportNotes,
    filter,
    fullscreen,
    help,
    homePin,
    house,
    incompleteCircle,
    info,
    insertPhoto,
    lightbulb,
    localShipping,
    lockOpen,
    mail,
    mobileOff,
    moped,
    moreVert,
    notifications,
    offlineBolt,
    openInFull,
    orderApprove,
    panTool,
    payments,
    person,
    pointOfSale,
    polyline,
    questionMark,
    rateReview,
    redo,
    refresh,
    remove,
    removeCircle,
    removeCircleOutline,
    removeShoppingCart,
    search,
    select,
    sell,
    separator,
    settings,
    shoppingBasket,
    shoppingCart,
    showChart,
    star,
    takeoutDining,
    timerOff,
    undo,
    visibility,
    visibilityOff
} from "../Specular.Components.IconList/index.js";
